import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  CircularProgress,
} from '@mui/material';
import { useAppSelector } from '../../store/hooks';

interface ViewGraphModalProps {
  open: boolean;
  onClose: () => void;
}

const ViewGraphModal: React.FC<ViewGraphModalProps> = ({ open, onClose }) => {
  const { selectedGraph, loading } = useAppSelector((state) => state.graphs);

  if (!selectedGraph && !loading) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Ver Grafo</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        ) : selectedGraph ? (
          <Box sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label="ID"
              value={selectedGraph.id}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Nodos"
              value={selectedGraph.nodes?.join(', ') || ''}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Tablas"
              value={selectedGraph.tables?.join(', ') || ''}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Tabla Base"
              value={selectedGraph.baseTable || ''}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Condición de Join"
              value={selectedGraph.joinCondition || ''}
              margin="normal"
              multiline
              rows={3}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Reglas de Negocio"
              value={selectedGraph.businessRules || ''}
              margin="normal"
              multiline
              rows={3}
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Creado el"
              value={selectedGraph.createdAt}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Creado por"
              value={selectedGraph.createdBy || ''}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Actualizado el"
              value={selectedGraph.updatedAt}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
            <TextField
              fullWidth
              label="Actualizado por"
              value={selectedGraph.updatedBy || ''}
              margin="normal"
              InputProps={{ readOnly: true }}
              variant="filled"
            />
          </Box>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewGraphModal;
